import { Textarea } from '@/components/ui/textarea';
import type { MetadataSchemaField } from '@/types/metadata.types';

interface TextAreaFieldProps {
  field: MetadataSchemaField;
  value: unknown;
  onChange: (value: unknown) => void;
  error?: string;
  disabled?: boolean;
}

export default function TextAreaField({
  field,
  value,
  onChange,
  error,
  disabled,
}: TextAreaFieldProps) {
  return (
    <Textarea
      id={field.fieldKey}
      placeholder={field.placeholder || ''}
      value={(value as string) || ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      maxLength={field.validationRules?.maxLength}
      rows={3}
      className={error ? 'border-destructive' : ''}
    />
  );
}
